import { ALL_GRADE_OPTIONS, AthleteTeamMember } from '@type/db-types';
import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useCallback } from 'react';
import { upsertAthlete } from '@modules/supabase/users';

interface Props {
    refresh?: () => void;
    user: AthleteTeamMember;
}

export default function GradeSelector({ refresh, user }: Props) {
    const onChange = useCallback(
        async ({ target: { value: grade } }: SelectChangeEvent) => {
            await upsertAthlete({ id: user.id, grade });
            refresh?.();
        },
        [refresh, user.id],
    );

    return (
        <Select size="small" onChange={onChange} value={user.grade}>
            {ALL_GRADE_OPTIONS.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                    <Typography variant="body2">{label}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
